(function() {
  angular.module('benefits')
    .service('benefitService', ['$stateParams','$log','$filter', function($stateParams,$log,$filter) {
      var validUnits = ['days','months','years'];
      var relationshipText = {"child":"Children are", "spouse": "Spouse is", "subscriber": "Subscriber is"};
      var orthoCategoryId = 26;
      var lifeTimeDate = '9999-12-31';
      var teledentSystem = "TeleDent";
      function ageLimitation(category, benefitInfo) {
        var limitations;
        var res = {
          covered: true,
          showTermText: true,
          label: "",
          ageLimitAvailable: true
        };
        if (category
          && (category.coinsuranceInNetwork || category.coinsuranceOutNetwork || (category.copayAmount != null))
          && (category.id == orthoCategoryId || (category.procedureCode >= 8000 && category.procedureCode < 9000))) {
          limitations = category.limitations
          if(limitations
            && (limitations["child"] && limitations["child"].max == 999)
            && (limitations["subscriber"] && limitations["subscriber"].max == 999)
            && (limitations["spouse"] && limitations["spouse"].max == 999)){
            res.showTermText = false;
            res.text = '<span class="text-info">No age limit</span>';
            return res;
          }
        }
        if (category && category.limitations) {
          limitations = category.limitations;
          var cvrgThrDt = limitations.coveredThruDate;
          if (limitations[benefitInfo.relationship]) {
            var maxAgeObj = limitations[benefitInfo.relationship];
            let ageMaximum = maxAgeObj.max || limitations.ageMaximum;
            //Upto Age - Exceed logic
            var maxAgeExceeded = false;
            //Upto age - Satisfied logic
            var isSatisfiedTxt = false;
            //Will satisfied - response text not needed
            var resTextNotNeeded = false;
            //Coverage Between logic - response text display
            var cvrgBtwResTxt = false;
            if (cvrgThrDt && !cvrgThrDt.from && !cvrgThrDt.to && ageMaximum) {
              res.label = "Up to Age " + ageMaximum;
              isSatisfiedTxt = true;
              var maxAgeDate = moment(benefitInfo.dateOfBirth).add(ageMaximum, 'years');
              if (maxAgeDate && moment().isAfter(maxAgeDate)) {
                maxAgeExceeded = true;
              }
            } else {
              if (cvrgThrDt && cvrgThrDt.from && cvrgThrDt.to && cvrgThrDt.to != lifeTimeDate) {
                res.label = "Covered between " + $filter('portalDate')(cvrgThrDt.from)
                    + " and " + $filter('portalDate')(cvrgThrDt.to);
                cvrgBtwResTxt = true;
              }

              /*If ageMinimum is greate than 0 and Covered between dates - From Date >  today & to date is not 12/31/9999 - Same
              Covered thru lifetime, but coverage starts on a future date - Same (12/31/9999 condition is not needed)
              Covered thru lifetime, but coverage started (from date > today)
               */
              if(limitations.ageMinimum > 0) {
                if (cvrgThrDt && cvrgThrDt.from && moment().isBefore(cvrgThrDt.from)) {
                  res.label = "Age limitation will be satisfied on " + $filter('portalDate')(cvrgThrDt.from);
                  resTextNotNeeded = true;
                } else if (cvrgThrDt && cvrgThrDt.from && moment().isAfter(cvrgThrDt.from)) {
                  res.label = "Covered from  " + $filter('portalDate')(cvrgThrDt.from);
                  resTextNotNeeded = true;
                }
              }

            }
            //Covered between dates - To Date < today & to date is not 12/31/9999
            if ((cvrgThrDt && cvrgThrDt.to && cvrgThrDt.to != lifeTimeDate && moment().isAfter(cvrgThrDt.to) && cvrgBtwResTxt) || maxAgeExceeded) {
              res.covered = false;
              res.label = res.label + ":";
              res.text = '<span class="text-danger">Exceeded</span>';
            } else if ((cvrgThrDt && cvrgThrDt.to && cvrgThrDt.to != lifeTimeDate && moment().isBefore(cvrgThrDt.to) && cvrgBtwResTxt) || isSatisfiedTxt) {
              //Covered between dates - To Date> today & to date is not 12/31/9999
              res.covered = true;
              res.label = res.label + ":";
              res.text = '<span class="text-normal">Satisfied</span>';
            } else if (resTextNotNeeded) {
              res.text = '<span class="text-normal"></span>';
            }



          } else if (limitations[benefitInfo.relationship] === false) {
            res.covered = false;
            res.showTermText = false;
            res.text = '<span class="text-danger">' + relationshipText[benefitInfo.relationship.toLowerCase()] + ' not covered</span>';
          }
        }
        return res;
      }

      function waitingPeriod(waitPeriod, effectiveDate) {
        var res = {
          covered: {inNetwork: true, outNetwork: true},
          text: 'Satisfied'
        };
        if (waitPeriod && !waitPeriod.waived && (waitPeriod.inNetwork || waitPeriod.outNetwork)) {
          var unit = waitPeriod.units ? _.find(validUnits, waitPeriod.units.toLowerCase()) : "months";
          var unitsCompleted;
          if($stateParams.eligibilityAuditTS != null) {
            unitsCompleted = moment($stateParams.eligibilityAuditTS).diff(effectiveDate, unit);
          }else {
            unitsCompleted = moment().diff(effectiveDate,unit);
          }
          if (waitPeriod.inNetwork !== waitPeriod.outNetwork && (
            unitsCompleted < waitPeriod.inNetwork || unitsCompleted < waitPeriod.outNetwork)) {
            if (unitsCompleted < waitPeriod.inNetwork) {
              res.covered.inNetwork = false;
              res.text = moment(effectiveDate).add(waitPeriod.inNetwork, unit)
                .format('[<span class="text-danger">Will be satisfied on] M/D/YYYY [(In Network)</span>]');
            } else {
              res.text = 'Satisfied (In Network)';
            }
            if (unitsCompleted < waitPeriod.outNetwork) {
              res.covered.outNetwork = false;
              res.text += moment(effectiveDate).add(waitPeriod.outNetwork, unit)
                .format('[; <span class="text-danger">Will be satisfied on] M/D/YYYY [(Out of Network)</span>]');
            } else {
              res.text += '; Satisfied (Out of Network)';
            }
          } else if (unitsCompleted < waitPeriod.inNetwork) {
            res.covered.inNetwork = res.covered.outNetwork = false;
            res.text = moment(effectiveDate).add(waitPeriod.inNetwork, unit).format('[<span class="text-danger">Will be satisfied on] M/D/YYYY[</span>]');
          }
        }
        return res;
      }
      function hasDentalHmoPolicy(value) {
        if (!value) {
          return false;
        }
        if (Array.isArray(value)) {
          for (var i = 0; i < value.length; i++) {
            if (hasDentalHmoPolicy(value[i])) {
              return true;
            }
          }
          return false;
        }
        if (typeof value !== 'object') {
          return false;
        }

        var policyType = (value.policyType || value.type || '').toString().trim().toLowerCase();
        return policyType === 'dental hmo' || policyType === 'dhmo';
      }

      var isDentalHmo = false;
      var service =  {
        setIsDentalHmo: function(value) {
          isDentalHmo = !!value;
          return isDentalHmo;
        },
        isDentalHmo: function() {
          return isDentalHmo;
        },
        hasDentalHmoPolicy: hasDentalHmoPolicy,
        clearDashboardState: function() {
          isDentalHmo = false;
        },
        getMemberByRefId: function(refId) {
          return this.associatedMembersPromise.then(function(data) {
             return _.find(data, (m) => {
              return _.find(m.policies, (p) => {
                return p.referenceId == refId;
              });
            });
          });
        },
        getMembers: function() {
          return this.associatedMembersPromise.then(function(data) {
            return data;
          });
        },
        getPolicyByRefId: function(refId) {
          return this.getMemberByRefId(refId).then((member) => {
            if (!member) {
              return {};
            }
            return _.find(member.policies, (p) => p.referenceId === refId);
          });
        },
        getCopayScheduleParams: function(refId) {
          return this.getPolicyByRefId(refId).then((policy) => {
            if (!policy) {
              return {};
            }
            return {
              clientCode: policy.clientCode,
              planCode: policy.planCode
            };
          });
        },
        checkPolicyForBenefitBlock: function(refId) {
          return this.getMemberByRefId(refId).then((member) => {
            if (!member) {
              return {};
            }
            var policy =  _.find(member.policies, (p) => p.referenceId === refId);
            var rule = _.find(policy.rules, (r) => r.isBenefitBlock);
            return rule? rule.isBenefitBlock : false;
          });
        },
        checkPolicyForClaimBlock: function(refId) {
          return this.getMemberByRefId(refId).then((member) => {
            if (!member) {
              return {};
            }
            var policy =  _.find(member.policies, (p) => p.referenceId === refId);
            var rule = _.find(policy.rules, (r) => r.isClaimBlock);
            return rule? rule.isClaimBlock : false;
          });
        },
        filterCategories: function(categories, refId) {
          return this.getMemberByRefId(refId).then((member) => {
            if (!member) {
              return {};
            }
            var policy =  _.find(member.policies, (p) => p.referenceId === refId);
            var blockedCategories = [];
            var unblockedCategories = [];
            angular.forEach(policy.rules, function(rule, key) {
              if(rule.disallowCategory){
                blockedCategories = blockedCategories.concat(rule.disallowCategoryString.split("|"));
              }
            });
            angular.forEach(categories, function(category, key) {
              if(!blockedCategories.includes(category.name.toString())){
                unblockedCategories.push(category);
              }
            });
            return unblockedCategories;
          });
        },
        checkProcedureBlock: function(procedureCode, refId) {
          return this.getMemberByRefId(refId).then((member) => {
            if (!member) {
              return {};
            }
            var policy =  _.find(member.policies, (p) => p.referenceId === refId);
            var procedureValid = true;
            var blockedProcedures = [];
            angular.forEach(policy.rules, function(rule, key) {
              if(rule.procedureList){
                blockedProcedures = blockedProcedures.concat(rule.procedureList.split("|"));
              }
            });

            if(blockedProcedures.includes(procedureCode)) {
              procedureValid = false;
            }
            return procedureValid;
          });
        },
        ageLimitation: ageLimitation,
        waitingPeriod: waitingPeriod,
        getBenefitMaxCalculator: function(accumulators) {
          let maximums = _.filter(accumulators, (accum) => {
            return accum.type === 'maximum';
          });
          let maximumResults = new Map();
          _.each(maximums, (maximum) => {
            maximumResults.set(maximum.id, {
              inNetwork: !(maximum.remaining.individual.inNetwork === 0 || maximum.remaining.family.inNetwork === 0),
              outNetwork: !(maximum.remaining.individual.outNetwork === 0 || maximum.remaining.family.outNetwork === 0),
            });
          });
          return function(accumulatorIds) {
            //True means they have not reached the max
            return _.reduce(accumulatorIds, function(result, id) {
              if (maximumResults.get(id)) {
                result.inNetwork = result.inNetwork && maximumResults.get(id).inNetwork;
                result.outNetwork = result.outNetwork && maximumResults.get(id).outNetwork;
              }
              return result;
            }, {inNetwork: true, outNetwork: true});
          };
        },
        coveredForMember(procedureDetails, memberInfo, maxCalculator) {
          var result = {
            inNetwork: true,
            outNetwork: true,
            ageLimitAvailable: true
          };
          let belowMax = maxCalculator(procedureDetails.accumulators.id);
          $log.debug('Below max', belowMax);
          result.inNetwork = belowMax.inNetwork;
          result.outNetwork = belowMax.outNetwork;
          if (result.inNetwork || result.outNetwork) {
            this.planSummaryPromise.then(function(planSummary){
              let wp = waitingPeriod(procedureDetails.waitingPeriod, planSummary.enrollmentDate);
              $log.debug('Waiting period', wp);
              result.inNetwork = result.inNetwork && wp.covered.inNetwork;
              result.outNetwork = result.outNetwork && wp.covered.outNetwork;
            });
          }
          if (result.inNetwork || result.outNetwork) {
            let ageResult = ageLimitation(procedureDetails, memberInfo);
            $log.debug('Age limitation', ageResult);
            result.inNetwork = result.inNetwork && ageResult.covered;
            result.outNetwork = result.outNetwork && ageResult.covered;
            result.ageLimitAvailable = ageResult.ageLimitAvailable;
          }
          return result;
        }
      };
      return service;
    }]);
})();
